<template>
  <a-card title="工作量统计元素配置" style="margin-top: 5px">
    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
           <a @click="handleDelete(record.id)">删除</a>
        </span>
      </a-table>
      <a-button @click="handleAdd" type="primary" icon="plus" style="margin-top: 2px">添加</a-button>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <projectStatisticWorkloadConfig-modal ref="modalForm" @ok="modalFormOk"></projectStatisticWorkloadConfig-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import ProjectStatisticWorkloadConfigModal from './WorkloadConfig/ProjectStatisticWorkloadConfigModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import Vue from 'vue'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import { getAction,deleteAction,postAction } from '@/api/manage'

  export default {
    name: "ProjectStatisticWorkloadConfigList",
    mixins:[JeecgListMixin],
    components: {
      ProjectStatisticWorkloadConfigModal
    },
    data () {
      return {
        description: '工作量统计配置管理页面',
        projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
        disableMixinCreated:true,
        // 表头
        columns: [
          {
            title: '周期',
            align:"center",
            dataIndex: 'periodItemName'
          },
          {
            title: '表单',
            align:"center",
            dataIndex: 'formName'
          },
          {
            title: '表单元素',
            align:"center",
            dataIndex: 'formItemName'
          },

          {
            title: '匹配值',
            align:"center",
            dataIndex: 'value'
          },

          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/project/projectStatisticWorkloadConfig/list",
          delete: "/project/projectStatisticWorkloadConfig/delete",
       },
    }
  },
  computed: {
  },
    mounted(){

      this.baseQueryParam = {projectId:this.projectId}
      this.loadData()
    },
    methods: {

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>